import { render, staticRenderFns } from "./TeacherAgreementModal.vue?vue&type=template&id=63339b88&scoped=true"
import script from "./TeacherAgreementModal.vue?vue&type=script&lang=js"
export * from "./TeacherAgreementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63339b88",
  null
  
)

export default component.exports